import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

const CONTRACT_ADDRESS = "0x770dfE19F79506B724D094ad4CAC6a5dBb21F513";
const UNISWAP_URL = "https://app.uniswap.org/swap?outputCurrency=0x770dfE19F79506B724D094ad4CAC6a5dBb21F513&chain=ethereum";
const ETHERSCAN_URL = "https://etherscan.io/token/0x770dfE19F79506B724D094ad4CAC6a5dBb21F513";

const socialLinks = [
  { name: "Twitter", icon: "𝕏", href: "#" },
  { name: "Telegram", icon: "✈", href: "#" },
  { name: "DexTools", icon: "📊", href: `https://www.dextools.io/app/en/ether/pair-explorer/${CONTRACT_ADDRESS}` },
  { name: "Etherscan", icon: "🔍", href: ETHERSCAN_URL },
];

const Footer = () => {
  return (
    <footer className="bg-[#05000A] border-t border-[#9D4CDD]/20 py-16 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="md:col-span-5 space-y-6">
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="font-heading text-6xl md:text-8xl font-black text-[#FFD700] tracking-tighter"
            >
              $MOJO
            </motion.h2>
            <p className="text-[#A199AA] font-body text-sm leading-relaxed max-w-md">
              MojoCoin is the premier meme coin for those who appreciate true evil genius. 
              Join the most intellectually superior community in all of DeFi.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-[#0F0518] border border-[#9D4CDD]/30 hover:border-[#FFD700]/50 hover:bg-[#FFD700]/10 transition-all text-lg"
                  data-testid={`social-${social.name.toLowerCase()}`}
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3 space-y-4">
            <h3 className="font-heading text-lg font-bold text-white uppercase tracking-wider">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {["Home", "About", "Roadmap", "How to Buy"].map((link, index) => (
                <li key={index}>
                  <a
                    href={`#${link.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-[#A199AA] hover:text-[#FFD700] transition-colors font-body text-sm"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div className="md:col-span-4 space-y-4">
            <h3 className="font-heading text-lg font-bold text-white uppercase tracking-wider">
              Resources
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={ETHERSCAN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-[#A199AA] hover:text-[#FFD700] transition-colors font-body text-sm"
                >
                  Contract on Etherscan
                  <ExternalLink size={14} />
                </a>
              </li>
              <li>
                <a
                  href={UNISWAP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-[#A199AA] hover:text-[#FFD700] transition-colors font-body text-sm"
                >
                  Trade on Uniswap
                  <ExternalLink size={14} />
                </a>
              </li>
              <li>
                <a
                  href={`https://www.dextools.io/app/en/ether/pair-explorer/${CONTRACT_ADDRESS}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-[#A199AA] hover:text-[#FFD700] transition-colors font-body text-sm"
                >
                  View on DexTools
                  <ExternalLink size={14} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#9D4CDD]/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#A199AA] text-xs font-body text-center md:text-left">
              © 2024 MojoCoin. All rights reserved. Powered by evil genius.
            </p>
            <p className="text-[#A199AA]/60 text-xs font-body text-center max-w-lg italic">
              Disclaimer: MojoCoin ($MOJO) is a meme coin with no intrinsic value or financial return expectation. 
              This is not financial advice. Do not buy if you hate monkeys or dislike world domination.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
